import {gql} from 'apollo-boost'

export default gql`query project($project_id: String!){
  project(project_id: $project_id){
    project_id_prefix
    project_id
    name
    timesheet_months
    min_timesheet_date
    project_status{
      project_status_id
      description
      hexcode
    }
    project_manager{
      first_name
      last_name
    }
    project_director{
      first_name
      last_name
    }
    clients{
      name
    }
    total_budget
    total_fees
    total_supplier_invoiced
    total_writeoff
    total_invoiced
    total_credit_notes
    amount_to_invoice
    project_activity_budgets{
      description
      amount
      hours_worked
      budget_total
      budget_used
      stage
      amount_to_invoice
      project_activity_type_id
      project_activity_type{
        description
      }
      address{
        full_address
      }
      timesheets{
        id
        timesheet_date
        hours_worked
        role_hourly_rate
      }
      invoice_breakdowns{
        id
        amount
        project_client_invoice{
          type_id
          created_at
        }
      }
    }
    
  }
}`